import dayjs, { Dayjs } from 'dayjs';
import { isNonNullish } from 'remeda';

import { UserGuideType } from 'v2/constants';
import { Nullable } from 'v2/types';

export interface UserGuideStatisticsForm {
  guideType: UserGuideType;
  startDate: Nullable<Dayjs>;
  endDate: Nullable<Dayjs>;
}

export const initialValues: UserGuideStatisticsForm = {
  guideType: UserGuideType.INTRO,
  startDate: null,
  endDate: dayjs(),
};

export function isAllFieldsFilled(values: UserGuideStatisticsForm): boolean {
  return Object.values(values).every(isNonNullish);
}
